import {Paper} from "@mantine/core";
import Box from "@mui/material/Box";
import Popper from "@mui/material/Popper";
import Typography from "@mui/material/Typography";
import {isOverflown} from "@mui/x-data-grid/utils/domUtils";
import React from "react";

const GridCellExpand = React.memo(function GridCellExpand(
	props,
) {
	const {width, value} = props;
	const wrapper = React.useRef(null);
	const cellDiv = React.useRef(null);
	const cellValue = React.useRef(null);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [showFullCell, setShowFullCell] = React.useState(false);
	const [showPopper, setShowPopper] = React.useState(false);

	const handleMouseEnter = () => {
		const isCurrentlyOverflown = isOverflown(cellValue.current);
		setShowPopper(isCurrentlyOverflown);
		setAnchorEl(cellDiv.current);
		setShowFullCell(true);
	};

	const handleMouseLeave = () => {
		setShowFullCell(false);
	};

	React.useEffect(() => {
		if (!showFullCell) {
			return undefined;
		}

		function handleKeyDown(nativeEvent) {
			// IE11, Edge (prior to using Bink?) use 'Esc'
			if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
				setShowFullCell(false);
			}
		}

		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [setShowFullCell, showFullCell]);

	return (
		<Box
			ref={wrapper}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			sx={{
				alignItems: 'center',
				lineHeight: '24px',
				width: '100%',
				height: '100%',
				position: 'relative',
				display: 'flex',
			}}
		>
			<Box
				ref={cellDiv}
				sx={{
					height: '100%',
					width,
					display: 'block',
					position: 'absolute',
					top: 0,
				}}
			/>
			<Box
				ref={cellValue}
				sx={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
			>
				{value}
			</Box>
			{showPopper && (
				<Popper
					open={showFullCell && anchorEl !== null}
					anchorEl={anchorEl}
					sx={{width, marginLeft: -17}}
				>
					<Paper
						elevation={8}
						style={{
							minHeight: wrapper.current.offsetHeight - 3,
							border: '1px solid ',
							borderColor: '#ccc',
							backgroundColor: '#fff'
						}}

					>
						<Typography variant="body2" style={{padding: 8, textDecoration: 'underline', lineHeight: '32px'}}>
							{value}
						</Typography>
					</Paper>
				</Popper>
			)}
		</Box>
	);
});

export default GridCellExpand;
